import { render, staticRenderFns } from "./RejectedFilesTable.vue?vue&type=template&id=74a2c542&scoped=true&"
import script from "./RejectedFilesTable.vue?vue&type=script&lang=js&"
export * from "./RejectedFilesTable.vue?vue&type=script&lang=js&"
import style0 from "./RejectedFilesTable.vue?vue&type=style&index=0&id=74a2c542&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a2c542",
  null
  
)

export default component.exports